var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 600,
    stroke: "black",
    strokeWidth: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Abstract user icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 265
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 230,
    r: 115
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.81863443903,481.4 a205,205 1 0,1 386.36273112194,0",
    strokeLinecap: "butt"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.9fd9547f6f53286029f1cea1b2b28ffe.svg";
export { ForwardRef as ReactComponent };